import { Box, Divider, Typography, useTheme } from '@mui/material';
import { Stack } from '@mui/system';
import { Outlet, useParams } from 'react-router-dom';
import { CARDS } from '../../../constants/cards';
import { CardItem } from '../../../types/common';

const GeneratorPage: React.FC = () => {
  const theme = useTheme();
  const { url } = useParams();
  const { name, description, icon } = CARDS.find((card) => card.url === url) as CardItem;

  return (
    <Stack
      sx={{
        flex: 1,
        background: theme.custom.palette.primary.white,
        p: '20px 0 0',
      }}
    >
      <Divider light />
      <Stack
        direction={'row'}
        alignItems={'center'}
        gap={{
          mobile: '20px',
          tablet: '40px',
        }}
        p={{
          mobile: '10px',
          laptop: '20px',
        }}
      >
        <Box sx={{ fontSize: '36px' }}>{icon}</Box>

        <Box>
          <Typography
            sx={{
              typography: {
                mobile: 'h3',
                tablet: 'h1',
              },
            }}
          >
            {name}
          </Typography>
          <Typography variant="subtitle1">{description}</Typography>
        </Box>
      </Stack>

      <Divider light />

      <Outlet />
    </Stack>
  );
};

export default GeneratorPage;
